import { Configuration, PopupRequest, RedirectRequest } from "@azure/msal-browser";
import appConfig from "./appConfig";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
	auth: {
		clientId: appConfig.entraID.clientId,
		authority: `https://login.microsoftonline.com/${appConfig.entraID.tenantId}`,
		redirectUri: appConfig.entraID.redirectUri,
		postLogoutRedirectUri: appConfig.entraID.postLogoutRedirectUri,
	},
	cache: {
		cacheLocation: "localStorage", // <-- Persist tokens in localStorage
		storeAuthStateInCookie: true // helps mitigate issues in older browsers
	}	
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
	scopes: ['User.Read', 'email', 'profile', 'openid', 'offline_access', `api://${appConfig.entraID.authServerName}/${appConfig.entraID.userImpersonationScope}`]
};